import React from "react";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import "@/App.css";
import { I18nProvider } from "./i18n";
import { SettingsProvider } from "./context/SettingsContext";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import CampaignDetail from "./pages/CampaignDetail";
import Impact from "./pages/Impact";
import IslamicGiving from "./pages/IslamicGiving";
import AayatLibrary from "./pages/AayatLibrary";
import Media from "./pages/Media";
import MediaDetail from "./pages/MediaDetail";
import ZakatCalculator from "./pages/ZakatCalculator";
import CSR from "./pages/CSR";
import Technology from "./pages/Technology";
import Transparency from "./pages/Transparency";
import Legal from "./pages/Legal";
import Contact from "./pages/Contact";
import VerifyReceipt from "./pages/VerifyReceipt";
import StripeReturn from "./pages/StripeReturn";
import AdminApp from "./pages/admin/AdminApp";
import AuthCallback from "./pages/admin/AuthCallback";

function RedirectToInitiative() {
  const { slug } = useParams();
  return <Navigate to={`/initiatives/${slug}`} replace />;
}

function AppRouter() {
  const location = useLocation();
  React.useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
  // Process OAuth session_id from URL fragment BEFORE any route/auth check (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/programs/:slug" element={<Programs />} />
        <Route path="/initiatives/:slug" element={<CampaignDetail />} />
        <Route path="/donations/:slug" element={<RedirectToInitiative />} />
        <Route path="/campaign/:slug" element={<RedirectToInitiative />} />
        <Route path="/cause/:slug" element={<RedirectToInitiative />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/islamic-giving" element={<IslamicGiving />} />
        <Route path="/aayat" element={<AayatLibrary />} />
        <Route path="/media" element={<Media />} />
        <Route path="/media/:slug" element={<MediaDetail />} />
        <Route path="/zakat-calculator" element={<ZakatCalculator />} />
        <Route path="/csr" element={<CSR />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/transparency" element={<Transparency />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/verify-receipt/:receiptNumber" element={<VerifyReceipt />} />
        <Route path="/verify-receipt" element={<VerifyReceipt />} />
        <Route path="/payment/return" element={<StripeReturn />} />
      </Route>
      <Route path="/admin/*" element={<AdminApp />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </I18nProvider>
  );
}
